export default {
	data() {
		return {
		}
	},
	mounted() {
	},
	methods: {
		toPage(path) {
			this.$router.push(path).catch()
		}
	}
}
